var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponseCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0313 0.446777C14.4141 0.446777 0 14.9522 0 32.6814C0 50.4107 14.4141 64.9161 32.0313 64.9161C49.6485 64.9161 64.0626 50.4107 64.0626 32.6814C64.0626 14.9522 49.6485 0.446777 32.0313 0.446777ZM32.0313 60.8865C16.6162 60.8865 4.00391 48.1939 4.00391 32.6814C4.00391 17.169 16.6162 4.47593 32.0313 4.47593C47.4464 4.47593 60.0587 17.1685 60.0587 32.681C60.0587 48.1935 47.4464 60.8865 32.0313 60.8865Z",
    fill: "#3ED598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6437 23.2122L28.0275 39.9339L19.6193 31.4727C18.8185 30.6669 17.6173 30.6669 16.8165 31.4727C16.0157 32.2785 16.0157 33.4873 16.8165 34.2931L26.6261 44.1648C27.0265 44.5677 27.4269 44.7694 28.0275 44.7694C28.6281 44.7694 29.0285 44.5677 29.4289 44.1648L47.4465 26.0331C48.2473 25.2273 48.2473 24.0185 47.4465 23.2127C46.6457 22.4064 45.4445 22.4064 44.6437 23.2122Z",
    fill: "#3ED598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseCompleteIcon);
export default __webpack_public_path__ + "static/media/response-complete-icon.51f5e2498d7bb7913995f1ec9d465857.svg";
export { ForwardRef as ReactComponent };